import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import CompanyPromotion from "../PdfQuotationsTables/company_promotion";
import ElectricFittings from "../PdfQuotationsTables/electric_fittings";
import performRequest from "../../../api/request";
import { useNavigate, useParams } from "react-router-dom";
import CompanyDescription from "../PdfQuotationsTables/company_description";
import NVPHSpecifications from "../PdfQuotationsTables/nvph_specifications";
import FanPadSpecifications from "../PdfQuotationsTables/fan_pad_specifications";
import AFrameSetup from "../PdfQuotationsTables/a_frame_setup";
import FlatBedSetup from "../PdfQuotationsTables/flat_bed_setup";
import GrowBagSetup from "../PdfQuotationsTables/grow_bag_setup";
import DutchBucketSetup from "../PdfQuotationsTables/dutch_bucket_setup";
import WaterStorageHandling from "../PdfQuotationsTables/water_storage_and_handling";
import EmployeeTrainingProgramme from "../PdfQuotationsTables/employee_training_programme";
import AgronomySupport from "../PdfQuotationsTables/agronomy_support";
import ScopeOfWork from "../PdfQuotationsTables/scope_of_work";
import CustomerResponsibility from "../PdfQuotationsTables/customer_responsibility";
import CivilMaterials from "../PdfQuotationsTables/civil_materials";
import SoftwareServices from "../PdfQuotationsTables/software_services";
import MaterialBreakdown from "../PdfQuotationsTables/material_breakdown";
import WorkOrderLocations from "../PdfQuotationsTables/work_order_locations";
import WarrantyOnMaterial from "../PdfQuotationsTables/warranty_on_material";
import TrackingOfProgress from "../PdfQuotationsTables/tracking_of_progress";
import NetHouseSpecifications from "../PdfQuotationsTables/net_house_specifications";
import PaymentDetails from "../PdfQuotationsTables/payment_details";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Toast } from "../../../CustomComponent/toast";
import KryzenTop from "../PdfQuotationsTables/kryzen_Top";
import ProjectFinancials from "../PdfQuotationsTables/project_financials";
import QuotationAmounts from "../PdfQuotationsTables/quotation_amounts";
import PaymentBreakdown from "../PdfQuotationsTables/payment_breakdown";
import ProduceBreakevenTable from "../PdfQuotationsTables/produce_breakeven_table";
import UserDetails from "../PdfQuotationsTables/user_details";
import MaterialBreakdownCEA from "../PdfQuotationsTables/material_breakdown_CEA";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcSurvey } from "react-icons/fc";
import WhatsAppButton from "../../../Components/layouts/whatsApp_button";
import Soilbased_precision_farming from "../PdfQuotationsTables/soilbased_precision_farming";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

const QuotationPreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [allQData, setAllQData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [quot, setQuot] = useState();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotations/getQuotationsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setdata(res.data?.input_info);
          setAllQData(res.data);
          setQuot(res.data?.quotationNumber);
        } else {
          Toast("error", "Error while getting Quotations!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, id]);
  const [sendingWhatspp, setSendingWhatspp] = useState(false);

  function QuotationNumber() {
    return id.toString().padStart(4, "0");
  }
  function GetArea() {
    let area = data?.bay_size * data?.span_size;
    return area;
  }

  function joinWithDash(inputString) {
    var wordsArray = inputString.split(" ");
    var joinedString = wordsArray.join("-");
    return joinedString;
  }
  const printPDF = () => {
    let name = joinWithDash(
      `${QuotationNumber()}-${GetArea()}SqM-${
        data?.businessName || data?.contactPersonName
      }-${getQuotationFor(allQData?.input_info)}.pdf`
    );
    document.title = name;
    window.print();
  };
  const handleGenerateAndSendWhatsAppPDF = () => {
    const htmlContent = document.getElementById("pdf-content").innerHTML;
    let name = joinWithDash(
      `${QuotationNumber()}-${GetArea()}SqM-${
        data?.businessName || data?.contactPersonName
      }-${getQuotationFor(allQData?.input_info)}.pdf`
    );
    if (!data?.whatsAppNumber) {
      Toast("error", "WhatsApp number not added for this Quotations!");
    } else if (data?.whatsAppNumber && data?.whatsAppNumber?.length !== 10) {
      Toast("error", "WhatsApp number must be of 10 digits!");
    } else {
      setSendingWhatspp(true);
      performRequest("POST", "/quotations/sendQuotationToWhatsapp", {
        quotDetails: data,
        pdfName: name,
        htmlContent,
      })
        .then((res) => {
          if (res.status === 200) {
            Toast(
              "success",
              `Pdf sent successfully on whatsapp ${data.whatsAppNumber}`
            );
          } else {
            Toast("error", "error while sending!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setSendingWhatspp(false));
    }
  };
  function generatePDF() {
    setLoading(true);
    performRequest(
      "PATCH",
      quot.includes("A/V2")
        ? `/quotations/updateQuotations/${id}`
        : `/quotations/updateQuotationOld/${id}`,
      {
        pdfStatus: true,
      }
    )
      .then((res) => {
        if (res.status === 200) {
          setRefresh(!refresh);
          Toast("success", "PDF generated successfully!");
        } else {
          Toast("error", "Error while generating PDF!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }

  function handelEdit() {
    navigate(`/custom-quotation/edit-quotation/${id}`);
  }
  const duplicateQuotation = () => {
    navigate(`/custom-quotation/new-quotation?duplicate=${id}`);
  };
  useEffect(() => {
    if (data?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("pdf-content");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [data]);
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2  me-1" /> Custom quotations
                </h2>
                <h4 className="text-muted">
                  Custom quotation for{" "}
                  {data?.businessName || data?.contactPersonName}
                </h4>
              </div>
              {allQData?.input_info?.pdfStatus && (
                <div className="col-md-4">
                  <div className="btn-list justify-content-end">
                    <WhatsAppButton
                      buttonText={sendingWhatspp ? "SENDING..." : "SEND QUOTE"}
                      disabled={sendingWhatspp ? true : false}
                      style={{
                        height: "46px",
                        marginTop: "8px",
                        backgroundColor: "#10c245",
                        color: "white",
                      }}
                      svg={
                        sendingWhatspp ? (
                          <div
                            class="spinner-border me-2 fs-1 spinner-border-sm text-white"
                            role="status"
                          ></div>
                        ) : (
                          ""
                        )
                      }
                      onClick={handleGenerateAndSendWhatsAppPDF}
                    />
                    <SimpleButton buttonText={"save pdf"} onClick={printPDF} />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" id="pdf-content">
              <KryzenTop />
              {data && (
                <CompanyDescription
                  allQData={allQData}
                  businessName={data?.businessName || data?.contactPersonName}
                  address={data?.address}
                  data={data}
                  quotationType={data?.quotationType}
                />
              )}
              {data && <UserDetails userInfo={data} area={allQData?.area_in} />}
              {data &&
                (data?.quotationType === "fanpad" ||
                  data?.quotationType === "soilbasedfanpad") && (
                  <FanPadSpecifications quotationType={data?.quotationType} />
                )}

              {data && data?.quotationType === "fanpad with hydroponics" && (
                <FanPadSpecifications quotationType={data?.quotationType} />
              )}
              {data &&
                (data?.quotationType === "nethouse" ||
                  data?.quotationType === "soilbasednethouse") && (
                  <NetHouseSpecifications data={data} />
                )}
              {data && data?.quotationType === "nethouse with hydroponics" && (
                <NetHouseSpecifications data={data} />
              )}
              {data &&
                (data?.quotationType === "nvph" ||
                  data?.quotationType === "soilbasednvph") && (
                  <NVPHSpecifications />
                )}
              {data && data?.quotationType === "nvph with hydroponics" && (
                <NVPHSpecifications />
              )}
              {(data?.quotationType === "soilbasedfanpad" ||
                data?.quotationType === "soilbasednvph" ||
                data?.quotationType === "soilbasednethouse") && (
                <Soilbased_precision_farming />
              )}
              {/* percent wise setup */}
              {data?.quotationType !== "fanpad" &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "nethouse" &&
                data?.quotationType !== "soilbasedfanpad" &&
                data?.quotationType !== "soilbasednvph" &&
                data?.quotationType !== "soilbasednethouse" && (
                  <>
                    {data && data?.flatBedPercent > 0 && <FlatBedSetup />}
                    {data && data?.a_FramePercent > 0 && <AFrameSetup />}
                    {data && data?.growBagPercent > 0 && <GrowBagSetup />}
                    {data && data?.dutchBucketPercent > 0 && (
                      <DutchBucketSetup />
                    )}
                    <div
                      className="html2pdf__page-break"
                      style={{
                        pageBreakAfter: "always",
                        display: "block",
                        clear: "both",
                      }}
                    ></div>
                  </>
                )}

              {data &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "soilbasednvph" && (
                  <WaterStorageHandling
                    quotationType={data?.quotationType}
                    data={data}
                  />
                )}

              {data &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "soilbasednvph" && (
                  <ElectricFittings
                    data={data}
                    quotationType={data?.quotationType}
                  />
                )}
              {data?.quotationType !== "fanpad" &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "nethouse" &&
                data?.quotationType !== "soilbasedfanpad" &&
                data?.quotationType !== "soilbasednvph" &&
                data?.quotationType !== "soilbasednethouse" && (
                  <>
                    <EmployeeTrainingProgramme />
                    <AgronomySupport />
                  </>
                )}
              <TrackingOfProgress />

              {data && <ScopeOfWork quotationType={data?.quotationType} />}
              <CustomerResponsibility quotationType={data?.quotationType} />
              <CivilMaterials quotationType={data?.quotationType} />
              {/* working panding */}
              {/* <AfterSalesServices_AMC /> */}
              {data?.quotationType !== "fanpad" &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "nethouse" &&
                data?.quotationType !== "soilbasedfanpad" &&
                data?.quotationType !== "soilbasednvph" &&
                data?.quotationType !== "soilbasednethouse" && (
                  <SoftwareServices />
                )}
              {data &&
                data?.quotationType !== "hydroponics only" &&
                data?.quotationType !== "fanpad" &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "nethouse" &&
                data?.quotationType !== "soilbasedfanpad" &&
                data?.quotationType !== "soilbasednvph" &&
                data?.quotationType !== "soilbasednethouse" && (
                  <MaterialBreakdown />
                )}
              {(data?.quotationType === "fanpad" ||
                data?.quotationType === "nvph" ||
                data?.quotationType === "nethouse" ||
                data?.quotationType === "soilbasedfanpad" ||
                data?.quotationType === "soilbasednvph" ||
                data?.quotationType === "soilbasednethouse") && (
                <MaterialBreakdownCEA quotationType={data?.quotationType} />
              )}
              {data && (
                <WorkOrderLocations quotationType={data?.quotationType} />
              )}
              <WarrantyOnMaterial quotationType={data?.quotationType} />
              <CompanyPromotion />
              {data && data?.showProjectFinancials && (
                <>
                  {data && data?.showProjectFinancials && allQData && (
                    <ProjectFinancials
                      allQData={allQData}
                      quotationType={data?.quotationType}
                    />
                  )}
                  {allQData && allQData?.plant_grow?.updatedPlantsList && (
                    <ProduceBreakevenTable allQData={allQData} />
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      objectFit: "contain",
                      marginTop: "12px",
                    }}
                  >
                    <img
                      src={
                        "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079851/whyWeChooseKBPL_nwyh7d_xliuvq_jj8uap.png"
                      }
                      width={"80%"}
                      alt="kryzenCertificates"
                    />
                  </div>

                  <div
                    className="html2pdf__page-break"
                    style={{
                      pageBreakAfter: "always",
                      display: "block",
                      clear: "both",
                    }}
                  ></div>
                </>
              )}

              <KryzenTop />
              {allQData && (
                <QuotationAmounts
                  allQData={allQData}
                  quotationType={data?.quotationType}
                />
              )}
              {allQData && <PaymentBreakdown allQData={allQData} />}
              {data && <PaymentDetails data={data} />}
            </div>
            <div className="card-footer d-print-none">
              <div className="btn-list justify-content-end">
                {!allQData?.input_info?.pdfStatus && (
                  <SimpleButton
                    buttonText="Genarate PDF"
                    onClick={generatePDF}
                  />
                )}

                {allQData?.input_info?.pdfStatus && (
                  <SimpleButton buttonText="Print PDF" onClick={printPDF}>
                    Print PDF
                  </SimpleButton>
                )}

                <button
                  disabled={data?.finalQuotation}
                  className={`btn mx-1 mt-2 btn-primary`}
                  onClick={handelEdit}
                >
                  EDIT QUOTATION
                </button>
                {/* <SimpleButton
                  buttonText="Duplicate"
                  onClick={duplicateQuotation}
                /> */}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default QuotationPreview;
